/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEditSessionSnapshotDTO } from './pratica-edit-session-snapshot-dto';
import { RichiedenteCompactDTO } from './richiedente-compact-dto';


export interface PraticaOperatoreListItemDTO { 
    id?: string;
    codice_pratica?: string;
    richiedente?: RichiedenteCompactDTO;
    stato_dettaglio?: PraticaOperatoreListItemDTOStatoDettaglioEnum;
    timestamp_richiesta?: string;
    caricata_da_operatore?: boolean;
    punteggio_pratica?: number;
    codice_anpr?: string;
    codice_anpr_modificabile?: boolean;
    version?: number;
    edit_session?: PraticaEditSessionSnapshotDTO;
}
export enum PraticaOperatoreListItemDTOStatoDettaglioEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};



